import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Product from '../../../../model/product/product';
import { Project } from '../../../../model/project/project';
import ProjectContact from '../../../../model/company/projectContact';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';

@Component({
  selector: 'product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
  providers: [FormatPhoneNumber]
})
export class ProductDescriptionComponent implements OnInit {
  phoneOptions: string[];
  customTitle: boolean;

  @Input()
  public inputProject: Project;
  @Input()
  public inputProduct: Product;
  @Input()
  public client = false;
  @Input()
  public disabled = false;

  @Output()
  public updateProduct = new EventEmitter();

  titleOptions: any[] = [];
  selectedTitle: any;

  constructor(public formatPhoneNumber: FormatPhoneNumber) {}

  ngOnInit() {
    this.phoneOptions = [];
    this.titleOptions = [
      {
        id: 'Te_koop',
        label: 'Te koop'
      },
      {
        id: 'Te_huur',
        label: 'Te huur'
      },
      {
        id: 'Te_koop_Te_huur',
        label: 'Te koop/Te huur'
      },
      {
        id: 'A_vendre',
        label: 'A vendre'
      },
      {
        id: 'A_louer',
        label: 'A louer'
      },
      {
        id: 'Andere',
        label: 'Andere'
      }
    ];
    const selectedOption = this.titleOptions.find(
      option => this.inputProduct.title === option.label
    );
    this.selectedTitle = selectedOption == null ? null : selectedOption.label;
    if (this.inputProduct.title && this.selectedTitle == null) {
      this.customTitle = true;
      this.selectedTitle = this.titleOptions[
        this.titleOptions.length - 1
      ].label;
    }
    this.inputProduct.otherPhone = this.formatPhoneNumber.transform(
      this.inputProduct.otherPhone
    );
  }

  titleChange(title: string) {
    if (title === this.titleOptions[this.titleOptions.length - 1].label) {
      this.customTitle = true;
      this.inputProduct.title = '';
    } else {
      this.customTitle = false;
      this.inputProduct.title = title;
    }
    this.updateProduct.emit(this.inputProduct);
  }

  getPhoneNumbers(projectContact: ProjectContact) {
    let numbers: Array<string> = [];
    for (let phoneObject of projectContact.contact.telephones) {
      numbers.push(phoneObject.number);
    }
    for (let phoneObject of projectContact.company.telephones) {
      numbers.push(phoneObject.number);
    }
    return numbers;
  }

  getSelectedPhoneNumber(projectContact: ProjectContact) {
    if (this.inputProduct.phoneNumbers != null) {
      if (this.inputProduct.phoneNumbers.length === 0) {
        return;
      }

      for (let phoneNumber of this.getPhoneNumbers(projectContact)) {
        if (this.inputProduct.phoneNumbers.indexOf(phoneNumber) !== -1) {
          return phoneNumber;
        }
      }
    }
  }

  phoneNumberChosen(projectContact, phoneNumber) {
    this.removePreviousPhoneNumberFromList(projectContact);
    if (this.inputProduct.phoneNumbers != null) {
      this.inputProduct.phoneNumbers.push(phoneNumber);
    } else {
      this.inputProduct.phoneNumbers = [];
      this.inputProduct.phoneNumbers.push(phoneNumber);
    }
    this.updateProduct.emit();
  }

  removePreviousPhoneNumberFromList(projectContact: ProjectContact) {
    let selectedPhoneNumber = this.getSelectedPhoneNumber(projectContact);
    if (selectedPhoneNumber) {
      let index = this.inputProduct.phoneNumbers.indexOf(selectedPhoneNumber);
      this.inputProduct.phoneNumbers.splice(index, 1);
    }
  }

  otherPhoneChange(event) {
    this.inputProduct.otherPhone = this.formatPhoneNumber.transform(event);
    this.updateProduct.emit();
  }
}
